import React from 'react';

import { useNavigate } from "react-router-dom";

import { useContext } from 'react';

import { ClientContext } from '../../store/client-context.jsx';


import Card from '../../UI/Card';
import './CaseItem.css';



export default function CaseItem({ 

  control_num,
    patient_name,
    birth_date,
}){
     console.log ( 'control_num=', control_num); 
    
     const { changeCase } = useContext(ClientContext);

     const navigate = useNavigate();

     //const [ selectedCase, setSelectedCase]= useState ({ctxValue});
    function handleClick (){

      navigate ( '/pricing');
    }


  return (
    <li key={control_num} onClick={() => {changeCase(control_num); handleClick();  } }>
      <Card className='case-item'>
          <div style={{ "display": "grid", "grid-template-columns": "150px 400px 100px",  "color": "white", "text-align": "left" }}>
            <div>{control_num}</div><div>{patient_name}</div><div>{birth_date}</div>
         </div>   
      </Card>
    </li>
  );
};


